import React from "react";
import Select from "react-select";
import _ from "lodash";
import { _getTranslation } from "../utils/helper";

const InputSelect = (props) => {
  const _handleChange = (option) => {
    if (_.isArray(option)) {
      let selectedOptions = [];
      option.forEach((selected) => selectedOptions.push(selected.value));

      if (_.isEmpty(selectedOptions)) {
        // don't return empty array
        selectedOptions = "";
      }

      // console.log("A", props.name, selectedOptions);
      props.onChange(props.name, selectedOptions);
    } else if (option !== null) {
      // console.log("B", props.name, option.value, option);
      props.onChange(props.name, option.value, option);
    } else if (option === null && props.isMulti) {
      // console.log("C", props.name, []);
      props.onChange(props.name, []);
    } else {
      // console.log("D", props.name, "");
      props.onChange(props.name, "");
    }
  };

  return (
    <div
      className={`field-wrapper ${
        props.twoColumnLayout ? "grid sm:grid-cols-3 items-start gap-x-6" : ""
      } ${props.class ?? ""}`}
    >
      {props.label && (
        <label
          className={`text-mobileS md:text-desktopS font-bold block mb-2 ${
            props.twoColumnLayout ? "mt-3 sm:col-span-1" : ""
          }`}
        >
          {props.label}
        </label>
      )}
      <div className={`${props.twoColumnLayout ? "sm:col-span-2" : ""}`}>
        <Select
          {...props}
          onChange={(option) => _handleChange(option)}
          className={`react-select__container ${
            props.fakeNestedOptions ? "fake-nested-options" : ""
          } ${props.isSort ? "sort-dropdown" : ""} ${props.inputClass ?? ""}`}
          classNamePrefix="react-select"
          placeholder={props.placeholder || _getTranslation('select')}
        />

        {_.isString(props.error) && (
          <div className="form-error text-red-500 text-desktopXS mt-2">
            {props.error}
          </div>
        )}
      </div>
    </div>
  );
};

export default InputSelect;
